import Vue from 'vue';
import App from '@/App.vue';
import router from './router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import axios from 'axios';
import VueToast from 'vue-toast-notification';
import { setHeaderToken } from '@/utils/auth';
import 'vue-toast-notification/dist/theme-default.css';
import './assets/css/tailwind.css';
import 'vuetify/dist/vuetify.min.css';
import moment from 'moment';
import 'moment/locale/id';
moment.locale('id');

Vue.config.productionTip = false;
Vue.use(VueToast);

Vue.filter('terbilang', function (value) {
  function terbilang(a) {
    var c = ' Satu Dua Tiga Empat Lima Enam Tujuh Delapan Sembilan Sepuluh Sebelas'.split(' ');
    if (12 > a) var b = c[a];
    else
      20 > a
        ? (b = c[a - 10] + ' Belas')
        : 100 > a
          ? ((b = parseInt(String(a / 10).substr(0, 1))), (b = c[b] + ' Puluh ' + c[a % 10]))
          : 200 > a
            ? (b = 'Seratus ' + terbilang(a - 100))
            : 1e3 > a
              ? ((b = parseInt(String(a / 100).substr(0, 1))),
                (b = c[b] + ' Ratus ' + terbilang(a % 100)))
              : 2e3 > a
                ? (b = 'Seribu ' + terbilang(a - 1e3))
                : 1e4 > a
                  ? ((b = parseInt(String(a / 1e3).substr(0, 1))),
                    (b = c[b] + ' Ribu ' + terbilang(a % 1e3)))
                  : 1e5 > a
                    ? ((b = parseInt(String(a / 100).substr(0, 2))),
                      (a %= 1e3),
                      (b = terbilang(b) + ' Ribu ' + terbilang(a)))
                    : 1e6 > a
                      ? ((b = parseInt(String(a / 1e3).substr(0, 3))),
                        (a %= 1e3),
                        (b = terbilang(b) + ' Ribu ' + terbilang(a)))
                      : 1e8 > a
                        ? ((b = parseInt(String(a / 1e6).substr(0, 4))),
                          (a %= 1e6),
                          (b = terbilang(b) + ' Juta ' + terbilang(a)))
                        : 1e9 > a
                          ? ((b = parseInt(String(a / 1e6).substr(0, 4))),
                            (a %= 1e6),
                            (b = terbilang(b) + ' Juta ' + terbilang(a)))
                          : 1e10 > a
                            ? ((b = parseInt(String(a / 1e9).substr(0, 1))),
                              (a %= 1e9),
                              (b = terbilang(b) + ' Milyar ' + terbilang(a)))
                            : 1e11 > a
                              ? ((b = parseInt(String(a / 1e9).substr(0, 2))),
                                (a %= 1e9),
                                (b = terbilang(b) + ' Milyar ' + terbilang(a)))
                              : 1e12 > a
                                ? ((b = parseInt(String(a / 1e9).substr(0, 3))),
                                  (a %= 1e9),
                                  (b = terbilang(b) + ' Milyar ' + terbilang(a)))
                                : 1e13 > a
                                  ? ((b = parseInt(String(a / 1e10).substr(0, 1))),
                                    (a %= 1e10),
                                    (b = terbilang(b) + ' Triliun ' + terbilang(a)))
                                  : 1e14 > a
                                    ? ((b = parseInt(String(a / 1e12).substr(0, 2))),
                                      (a %= 1e12),
                                      (b = terbilang(b) + ' Triliun ' + terbilang(a)))
                                    : 1e15 > a
                                      ? ((b = parseInt(String(a / 1e12).substr(0, 3))),
                                        (a %= 1e12),
                                        (b = terbilang(b) + ' Triliun ' + terbilang(a)))
                                      : 1e16 > a &&
                                        ((b = parseInt(String(a / 1e15).substr(0, 1))),
                                        (a %= 1e15),
                                        (b = terbilang(b) + ' Kuadriliun ' + terbilang(a)));
    a = b.split(' ');
    c = [];
    for (b = 0; b < a.length; b++) '' != a[b] && c.push(a[b]);
    return c.join(' ');
  }
  return terbilang(value);
});

const token = localStorage.getItem('token');

if (token) {
  setHeaderToken(token);
}

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
// axios.defaults.baseURL = "https://dev-be.lugu.id";

import MoneyInput from '@/components/MoneyInput';
import GlobalFunctions from '@/plugins/global-functions';

Vue.use(GlobalFunctions);

Vue.component('money-input', MoneyInput);

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('LL');
  }
});

new Vue({
  router,
  store,
  vuetify,
  data: {
    loading: false,
  },
  render: (h) => h(App),
}).$mount('#app');
